import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import * as Util from '../../../common/utilities/';

import { Combobox, Tooltip } from '@salesforce/design-system-react';

import './SelectAgainComboboxGroup.scss';

const OPTIONS = [-1, 0, 1, 3, 5, 7, 14, 30, 60, 120, 180, 270, 365];
const DEFAULT_OPTION = 3;
const OPTIONS_MAX = [-1, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const DEFAULT_OPTION_MAX = 3;

class SelectAgainComboboxGroup extends Component {
  componentDidUpdate(prevProps) {
    const change = {};

    if (
      Util.propChanged(prevProps, this.props, 'open') &&
      OPTIONS.indexOf(prevProps.open) < 0
    ) {
      change.open = DEFAULT_OPTION;
    }
    if (
      Util.propChanged(prevProps, this.props, 'click') &&
      OPTIONS.indexOf(prevProps.click) < 0
    ) {
      change.click = DEFAULT_OPTION;
    }
    if (
      Util.propChanged(prevProps, this.props, 'max_selection') &&
      OPTIONS_MAX.indexOf(prevProps.max_selection) < 0
    ) {
      change.max_selection = DEFAULT_OPTION_MAX;
    }
    if (Object.keys(change).length > 0) {
      this.props.onChange(change);
    }
  }

  currentSelection(eventType) {
    const days = this.props[eventType];
    const selection = this.selectionFor(eventType, days);
    return selection ? [selection] : [];
  }

  selectionFor(eventType, days) {
    const { assetType } = this.props;
    const { formatMessage } = this.props.intl;
    const i18nKey = 'components.ecs.rules.selection';
    return {
      id: `components.ecs.rules.selection.${assetType}.${eventType}.${days}`,
      label: formatMessage({
        id: `${i18nKey}.${eventType}.${days}`
      }),
      value: days
    };
  }

  updateFor(eventType) {
    return (evt, data) => {
      if (data) {
        const value = data.selection && data.selection[0].value;
        const update = { [eventType]: value };

        this.props.onChange(update);
      }
    };
  }

  options(eventType) {
    return OPTIONS.map(this.selectionFor.bind(this, eventType));
  }

  optionsMax() {
    return OPTIONS_MAX.map(this.selectionFor.bind(this, 'max_selection'));
  }

  renderTooltip(eventType) {
    const { formatMessage } = this.props.intl;
    if (this.props.assetType === 'default') {
      return (
        <Tooltip
          align="top left"
          content={formatMessage({
            id: `components.ecs.rules.selection.${eventType}.tooltip`
          })}
          postition="absolute"
        />
      );
    }
  }

  render() {
    const { formatMessage } = this.props.intl;

    return (
      <div className="select-again-combobox-group">
        <div className="select-again-combobox">
          <Combobox
            id={`days-${this.props.assetType}-open`}
            labels={{
              label: formatMessage({
                id: 'components.ecs.rules.selection.open.label'
              })
            }}
            fieldLevelHelpTooltip={this.renderTooltip('open')}
            options={this.options('open')}
            selection={this.currentSelection('open')}
            events={{ onSelect: this.updateFor('open') }}
            variant="readonly"
          />
        </div>
        <div className="select-again-combobox">
          <Combobox
            id={`days-${this.props.assetType}-click`}
            labels={{
              label: formatMessage({
                id: 'components.ecs.rules.selection.click.label'
              })
            }}
            fieldLevelHelpTooltip={this.renderTooltip('click')}
            options={this.options('click')}
            selection={this.currentSelection('click')}
            events={{ onSelect: this.updateFor('click') }}
            variant="readonly"
          />
        </div>
        <div className="select-again-combobox">
          <Combobox
            id={`days-${this.props.assetType}-max_selection`}
            labels={{
              label: formatMessage({
                id: 'components.ecs.rules.selection.max_selection.label'
              })
            }}
            fieldLevelHelpTooltip={this.renderTooltip('max_selection')}
            options={this.optionsMax()}
            selection={this.currentSelection('max_selection')}
            events={{ onSelect: this.updateFor('max_selection') }}
            variant="readonly"
          />
        </div>
      </div>
    );
  }
}

SelectAgainComboboxGroup.propTypes = {
  open: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  click: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  max_selection: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  assetType: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(SelectAgainComboboxGroup);
